
import React, { useState } from "react"

import { DatePicker } from "antd"
import moment from "moment";
import { useEffect } from "react";
const {RangePicker} = DatePicker;

export const TrDateRange = ({label,setStartDate,setEndDate,error,myvalye,setMyvalye}) => {
  // const [sdate, setSDate] = useState(null);
  // const [edate, setEdate] = useState(null);

  const handleDateChange = (value) => {
    if (value && value.length === 2) {
      setMyvalye(value);
      const formattedStartDate = moment(value[0].$d).format("YYYY-MM-DD");
      const formattedEndDate = moment(value[1].$d).format("YYYY-MM-DD");
      setStartDate(formattedStartDate);
      setEndDate(formattedEndDate);
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  };

 

  return (
    <>
   <div className="mb-3 daterange_parent">
    {label ? <label className="form-label inputLable">{label}</label> : ''}
    <RangePicker 
    format="DD-MM-YYYY" 
    onChange={handleDateChange}
    value={myvalye}
    />
    <small className="text-danger">{error}</small>
    </div>
    </>
  )
}
